import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import { appointmentConsentsModalActions } from '../../../redux/healthboard/appointment-consent-modal';
import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import * as consent from '../../../redux/appointmentForm/requests/consent-req';
import {
  selectConsentFormPending,
  selectConsentFormUrl,
  selectConsentFormData,
  selectProgressCareUserId,
  selectProgressService,
  selectProgressVisitType,
  selectProgressIsUrgentVisitFlow,
  selectProgressScheduleLocationId,
  selectProgressScheduleProviderOrganizationName,
  selectProgressRescheduleData,
  selectProgressScheduleProvider,
} from '../../../redux/appointmentForm/selectors';
import styles from './styles.styl';

const mapStateToProps = state => ({
  loading: selectConsentFormPending(state),
  url: selectConsentFormUrl(state),
  userId: selectProgressCareUserId(state),
  visitType: selectProgressVisitType(state),
  service: selectProgressService(state),
  locationId: selectProgressScheduleLocationId(state),
  consentsData: selectConsentFormData(state),
  consentsLoading: selectConsentFormPending(state),
  organizationName: selectProgressScheduleProviderOrganizationName(state),
  isUrgentVisitFlow: selectProgressIsUrgentVisitFlow(state),
  rescheduleData: selectProgressRescheduleData(state),
  provider: selectProgressScheduleProvider(state),
});
const mapDispatchToProps = {
  fetchConsent: consent.actions.send,
  inspectConsent: appointmentProgressActions.inspectConsent,
  openModalConsents: appointmentConsentsModalActions.open,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ rescheduleData, provider }) => ({
    providerId: get(provider, 'id'),
    isRescheduleFlow: !!get(rescheduleData, 'id', null),
  })),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentConsentForm/enhance.js